import { Button } from "@/components/ui/button";
import { useRef } from "react";
import heroMosqueJpg from "@/assets/hero-mosque.jpg";
import { useScrollToSection } from "@/hooks/useScrollToSection";

const HeroSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { scrollToSection } = useScrollToSection();

  return (
    <section ref={sectionRef} className="relative h-[60vh] min-h-[400px] max-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img 
          src={heroMosqueJpg}
          alt="Beautiful mosque at sunset"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-charcoal/40 to-primary/70" />

      {/* Content */}
      <div className="relative z-10 container-mosque text-center px-4 pt-16">
        <div className="max-w-3xl mx-auto">
          {/* Decorative element */}
          <div className="flex justify-center mb-4 animate-fade-in-1">
            <div className="h-px w-12 bg-gradient-to-r from-transparent via-gold to-transparent" />
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-5 text-white tracking-tight animate-fade-in-2">
            Mesjid Al Sabur
          </h1>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center animate-fade-in-3">
            <Button 
              onClick={() => scrollToSection("#prayer-times")} 
              className="btn-gold text-sm sm:text-base px-6 py-5 shadow-lg"
            >
              View Prayer Times
            </Button>
            <Button 
              onClick={() => scrollToSection("#donate")} 
              className="btn-gold text-sm sm:text-base px-6 py-5 shadow-lg"
            >
              Support Our Mesjid
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
